export const removeBolds = text => {
  return text.replace(/<b>/g, "").replace(/<\/b>/g, "")
}

//-------------------------------------------------------------------
export const dayOfYear = date =>
  Math.floor(
    (date - new Date(date.getFullYear(), 0, 0)) / (1000 * 60 * 60 * 24)
  )

//-------------------------------------------------------------------
export const daysAgo = n => {
  let d = new Date()
  d.setDate(d.getDate() - Math.abs(n))
  return d
}

//-------------------------------------------------------------------
export const slugMaterialName = str => {
  return str.toLowerCase().replace(/ /g, "-")
}
